export const ACTIONS = {
}

export const MUTATIONS = {
  SET_REGISTERED_AS_NEW_USER: 'setRegisteredAsNewUser'
}
